import { Tab } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { DeputateSubjectContainersSubpage } from './DeputateSubjectContainersSubpage';
import { DeputateSubjectGroupsSubpage } from './DeputateSubjectGroupsSubpage';
import { DeputateSubjectsSubpage } from './DeputateSubjectsSubpage';

export const DeputateSetupSubjectsAndSubjectContainer = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <Tab
        variant='large'
        tabs={[
          {
            title: t('subject.title', { count: 2 }),
            value: 'subjects',
            content: <DeputateSubjectsSubpage />,
          },
          {
            title: t('subjectContainer.title', { count: 2 }),
            value: 'subjectContainers',
            content: <DeputateSubjectContainersSubpage />,
          },
          {
            title: t('subjectGroup.title', { count: 2 }),
            value: 'subjectGroups',
            content: <DeputateSubjectGroupsSubpage />,
          },
        ]}
      />
    </Page>
  );
};
